export default "__VITE_ASSET__249a3989__"